import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ServiceChargesService } from '../services/service-charges.service';

export const ServiceChargesResolver = () => {
  const serviceChargesService = inject(ServiceChargesService);
  const router = inject(Router);

  return serviceChargesService.getServiceCharges().pipe(
    map(response => response.data),
    catchError(error => {
      router.navigate(['/dashboard']);
      return of([]);
    })
  );
};
